import { render, staticRenderFns } from "./PendingApprovalNotificationStatus.vue?vue&type=template&id=644ec0a4&scoped=true&"
import script from "./PendingApprovalNotificationStatus.vue?vue&type=script&lang=js&"
export * from "./PendingApprovalNotificationStatus.vue?vue&type=script&lang=js&"
import style0 from "./PendingApprovalNotificationStatus.vue?vue&type=style&index=0&id=644ec0a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644ec0a4",
  null
  
)

export default component.exports